import {faComment} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Flex} from 'antd';
import {ReactElement, ReactNode, useMemo} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {gray7} from '../../../../../../../../css/var-export.scss';
import {LangKeyType} from '../../../../../../../../provider/locale/translation/type';
import {
    HistoryReplyItemType,
    ReviewReplyHistoryActionEnum,
} from '../../../../../../../../service/reviews/reviews-history-helper-type';

import {HistoryCatalogEditSection} from './history-catalog-edit-section';
import {HistoryExpandableText} from './history-expandable-text';

type PropsType = {
    formattedDate: string | null;
    formattedTime: string | null;
    item: HistoryReplyItemType;
    responseTime?: ReactNode;
    userName: string;
};

export function HistoryReplyLog(props: PropsType): ReactElement {
    const {formattedDate, formattedTime, item, responseTime, userName} = props;

    const actionLocaleString = useMemo((): LangKeyType => {
        if (item.action === ReviewReplyHistoryActionEnum.Created) {
            return 'REVIEWS__REVIEW_HISTORY__REPLY__CREATED';
        }

        if (item.action === ReviewReplyHistoryActionEnum.Updated) {
            return 'REVIEWS__REVIEW_HISTORY__REPLY__UPDATED';
        }

        return 'REVIEWS__REVIEW_HISTORY__REPLY__DELETED';
    }, [item.action]);

    const isUpdated = item.action === ReviewReplyHistoryActionEnum.Updated;

    return (
        <Flex gap={4} vertical>
            <Text secondary>
                {formattedDate} {formattedTime}
            </Text>
            <Flex gap={8} wrap>
                <FontAwesomeIcon color={gray7} fontSize={16} icon={faComment} />
                <Text lighter stringKey={actionLocaleString} valueMap={{user: <Text bolder>{userName}</Text>}} />
            </Flex>
            {item.action === ReviewReplyHistoryActionEnum.Created && responseTime}
            {isUpdated ? (
                <Flex gap={16} vertical>
                    <HistoryCatalogEditSection titleStringKey="REVIEWS__REVIEW_CHANGE_HISTORY__BEFORE">
                        <HistoryExpandableText value={item.oldValue} />
                    </HistoryCatalogEditSection>
                    <HistoryCatalogEditSection titleStringKey="REVIEWS__REVIEW_CHANGE_HISTORY__AFTER">
                        <HistoryExpandableText value={item.newValue} />
                    </HistoryCatalogEditSection>
                </Flex>
            ) : (
                <HistoryExpandableText
                    value={item.action === ReviewReplyHistoryActionEnum.Created ? item.newValue : item.oldValue}
                />
            )}
        </Flex>
    );
}
